export const FETCH_BIRTHDAYS = 'FETCH_BIRTHDAYS';
export const FETCH_BIRTHDAYS_SUCCESS = 'FETCH_BIRTHDAYS_SUCCESS';
export const FETCH_BIRTHDAYS_ERROR = 'FETCH_BIRTHDAYS_ERROR';

export const BIRTHDAY_FORM_SET_FIELD = 'BIRTHDAY_FORM_SET_FIELD';
export const BIRTHDAY_FORM_SET_ERRORS = 'BIRTHDAY_FORM_SET_ERRORS';
export const BIRTHDAY_FORM_RESET = 'BIRTHDAY_FORM_RESET';
export const BIRTHDAY_FORM_SUBMIT = 'BIRTHDAY_FORM_SUBMIT';
export const BIRTHDAY_FORM_SUBMIT_SUCCESS = 'BIRTHDAY_FORM_SUBMIT_SUCCESS';
export const BIRTHDAY_FORM_SUBMIT_ERROR = 'BIRTHDAY_FORM_SUBMIT_ERROR';

export const SET_NEW_USER = 'SET_NEW_USER';
export const FETCH_SHARED_BIRTHDAYS = 'FETCH_SHARED_BIRTHDAYS';
export const FETCH_SHARED_BIRTHDAYS_SUCCESS = 'FETCH_SHARED_BIRTHDAYS_SUCCESS';
export const FETCH_SHARED_BIRTHDAYS_ERROR = 'FETCH_SHARED_BIRTHDAYS_ERROR';
export const CLEAR_SHARED_BIRTHDAYS = 'CLEAR_SHARED_BIRTHDAYS';
